export default "__VITE_ASSET__DF_P8mRf__"